import React, { useMemo } from 'react';

/**
 * A hero mögötti hangulat három rétegből áll:
 *   1. lassan sodródó színfoltok (aurora),
 *   2. kifelé táguló fénygyűrűk,
 *   3. felfelé úszó szikrák.
 *
 * Mindhárom tisztán CSS-animáció, JS nélkül fut, és a `prefers-reduced-motion`
 * globális szabálya kikapcsolja őket.
 */
export default function HeroBackground() {
  const particles = useMemo(
    () =>
      Array.from({ length: 22 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 10,
        duration: 8 + Math.random() * 7,
        drift: (Math.random() - 0.5) * 80,
        size: 1.5 + Math.random() * 2.5,
      })),
    []
  );

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Sodródó színfoltok */}
      <div
        className="absolute -top-24 left-[12%] w-[38rem] h-[38rem] rounded-full blur-3xl animate-drift"
        style={{ background: 'radial-gradient(circle, rgba(109,85,234,0.22), transparent 65%)' }}
      />
      <div
        className="absolute -top-16 right-[10%] w-[34rem] h-[34rem] rounded-full blur-3xl animate-drift"
        style={{
          background: 'radial-gradient(circle, rgba(143,82,201,0.24), transparent 65%)',
          animationDelay: '-8s',
        }}
      />

      {/* Fénygyűrűk */}
      <div className="absolute top-[38%] left-1/2 -translate-x-1/2 -translate-y-1/2">
        {[0, 1.7, 3.4].map(delay => (
          <div
            key={delay}
            className="hero-ring"
            style={{
              width: 240,
              height: 240,
              marginLeft: -120,
              marginTop: -120,
              animationDelay: `${delay}s`,
            }}
          />
        ))}
      </div>

      {/* Szikrák */}
      {particles.map(p => (
        <span
          key={p.id}
          className="hero-particle"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            '--drift': `${p.drift}px`,
          }}
        />
      ))}

      {/* Alsó elhalványítás, hogy a szekció folytonosan menjen át a következőbe */}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-gray-950 to-transparent" />
    </div>
  );
}
